/**
 * Workspace path resolution utilities — extracted from EditorView for testability.
 */

/** Resolve a relative path against the directory of the current file */
export function resolveWorkspacePath(currentFile: string, relativeSrc: string): string {
    // Decode URL-encoded characters (e.g. %20 → space).
    // Invalid %-sequences can occur in user-authored markdown and should not crash rendering.
    const decoded = safeDecodeUriComponent(relativeSrc)
    if (decoded.startsWith('/')) return decoded
    const dir = currentFile.substring(0, currentFile.lastIndexOf('/')) || ''
    const parts = `${dir}/${decoded}`.split('/')
    const resolved: string[] = []
    for (const p of parts) {
        if (p === '..') resolved.pop()
        else if (p !== '.' && p !== '') resolved.push(p)
    }
    return '/' + resolved.join('/')
}

function safeDecodeUriComponent(value: string): string {
    try {
        return decodeURIComponent(value)
    } catch {
        return value
    }
}

/** Check if a URL is external (http, mailto, tel, anchor) */
export function isExternalUrl(href: string): boolean {
    return /^(https?:|mailto:|tel:|#)/.test(href)
}
